import DefaultDealershipIcon from './DefaultDealershipIcon';

export default DefaultDealershipIcon;
